/* Hero: rotates only the heading. Background, coupons and media stay put. */
class HeroHeadingRotator extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('[data-hero-heading]'));
    if (this.items.length < 2) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return; // leave the first heading showing

    this.index = 0;
    const seconds = parseFloat(this.dataset.interval) || 4;
    this.timer = setInterval(() => this.advance(), seconds * 1000);

    // don't animate while the tab is hidden
    this.onVisibility = () => (document.hidden ? this.stop() : this.start(seconds));
    document.addEventListener('visibilitychange', this.onVisibility);
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisibility);
  }

  start(seconds) {
    this.stop();
    this.timer = setInterval(() => this.advance(), seconds * 1000);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }

  advance() {
    this.items[this.index].classList.remove('is-active');
    this.index = (this.index + 1) % this.items.length;
    this.items[this.index].classList.add('is-active');
  }
}

if (!customElements.get('hero-heading-rotator')) {
  customElements.define('hero-heading-rotator', HeroHeadingRotator);
}
